import { makeStyles } from "@mui/styles";
import { fieldContainer, fieldLabel, fieldInput } from "../Form/fieldStyles";

const useStyles = makeStyles(() => ({
  container: fieldContainer,
  label: fieldLabel,
  textArea: {
    ...fieldInput,
    height: "auto",
    minHeight: "110px",
    padding: "12px 14px",
    lineHeight: 1.5,
    resize: "vertical",
  },
}));

export default useStyles;
